import { handleError } from 'config/libraries';
import React, {useEffect, useState} from 'react'
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';

export const Form = () => {
    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [DataLayanan, setDataLayanan] = useState([]);


    useEffect(() => {

        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/informasi?slug_kategori_informasi=layanan&per_page=100').then(function (response) {
            setDataLayanan(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataLayanan(null)
        };
    }, []);

    function submitSurvey(data) {
        const axios = require('axios');
        axios.post(process.env.REACT_APP_SERVER_BASE_URL + '/survei-kepuasan-masyarakat', {
            email_aktif: data.email_aktif,
            jenis_kelamin: data.jenis_kelamin,
            umur: data.umur,
            pendidikan_terakhir: data.pendidikan_terakhir,
            pekerjaan: data.pekerjaan,
            jenis_pelayanan_yang_diterima: data.jenis_pelayanan_yang_diterima,
            kesesuaian_pelayanan: data.kesesuaian_pelayanan,
            kemudahan_pelayanan: data.kemudahan_pelayanan,
            kecepatan_pelayanan: data.kecepatan_pelayanan,
            biaya_pelayanan: data.biaya_pelayanan,
            kesesuaian_produk_pelayanan: data.kesesuaian_produk_pelayanan,
            kemampuan_petugas: data.kemampuan_petugas,
            perilaku_petugas: data.perilaku_petugas,
            kualitas_saran_dan_prasarana: data.kualitas_saran_dan_prasarana,
            penanganan_pengaduan: data.penanganan_pengaduan,
            saran_saran: data.saran_saran,
        }).then(function (response) {
            toast.success('Survey Berhasil Dikirim', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }).catch(function (error) {
            if (error.response.data.message != null) {
                if (Array.isArray(error.response.data.message)) {
                    for (const key in error.response.data.message) {
                        toast.error(`${error.response.data.message[key]}`, {
                            position: "bottom-left",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                } else {
                    toast.error(`${error.response.data.message}`, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast.error('Survey Tidak Berhasil Dikirim', {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        });
    }

    return (
        <div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                toastStyle={{ backgroundColor: "#000", color: "#FFF", fontWeight: "bold" }}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <h1 className='mb-1'>Survey Kepuasan Masyarakat</h1>
            <p>Pandangan Anda terhadap pelayanan di lingkungan Dinas Pendidikan Kabupaten Lampung Timur </p>
            <form onSubmit={handleSubmit(submitSurvey)}>
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <label>Email</label>
                        <input type="email" {...register("email_aktif")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Jenis Kelamin</label>
                        <select className='form-control select-costum' {...register("jenis_kelamin")}>
                            <option value="laki-laki">laki-laki</option>
                            <option value="perempuan">perempuan</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Umur</label>
                        <input type="number" {...register("umur")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Pendidikan Terakhir</label>
                        <input type="text" {...register("pendidikan_terakhir")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Pekerjaan</label>
                        <input type="text" {...register("pekerjaan")} className='form-control'></input>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Jenis Pelayanan yang Diterima</label>
                        <select className='form-control select-costum' {...register("jenis_pelayanan_yang_diterima")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            {
                                DataLayanan && DataLayanan.map((item, index) => {
                                    return (
                                        <option key={index} value={item.judul_informasi}>{item.judul_informasi}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kesesuaian Pelayanan</label>
                        <select className='form-control select-costum' {...register("kesesuaian_pelayanan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Sesuai</option>
                            <option value="2">Kurang Sesuai</option>
                            <option value="3">Sesuai</option>
                            <option value="4">Sangat Sesuai</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kemudahan Pelayanan</label>
                        <select className='form-control select-costum' {...register("kemudahan_pelayanan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Mudah</option>
                            <option value="2">Kurang Mudah</option>
                            <option value="3">Mudah</option>
                            <option value="4">Sangat Mudah</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kecepatan Pelayanan</label>
                        <select className='form-control select-costum' {...register("kecepatan_pelayanan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Cepat</option>
                            <option value="2">Kurang Cepat</option>
                            <option value="3">Cepat</option>
                            <option value="4">Sangat Cepat</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Biaya Pelayanan</label>
                        <select className='form-control select-costum' {...register("biaya_pelayanan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Sangat Mahal</option>
                            <option value="2">Cukup Mahal</option>
                            <option value="3">Mahal</option>
                            <option value="4">Gratis</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kesesuaian Produk Pelayanan</label>
                        <select className='form-control select-costum' {...register("kesesuaian_produk_pelayanan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Sesuai</option>
                            <option value="2">Kurang Sesuai</option>
                            <option value="3">Sesuai</option>
                            <option value="4">Sangat Sesuai</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kemampuan Petugas</label>
                        <select className='form-control select-costum' {...register("kemampuan_petugas")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Kompeten</option>
                            <option value="2">Kurang Kompeten</option>
                            <option value="3">Kompeten</option>
                            <option value="4">Sangat Kompeten</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Perilaku Petugas</label>
                        <select className='form-control select-costum' {...register("perilaku_petugas")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Sopan dan Ramah</option>
                            <option value="2">Kurang Sopan dan Ramah</option>
                            <option value="3">Sopan dan Ramah</option>
                            <option value="4">Sangat Sopan dan Ramah</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Kualitas Saran dan Prasarana</label>
                        <select className='form-control select-costum' {...register("kualitas_saran_dan_prasarana")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Buruk</option>
                            <option value="2">Cukup</option>
                            <option value="3">Baik</option>
                            <option value="4">Sangat Baik</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Penanganan Pengaduan</label>
                        <select className='form-control select-costum' {...register("penanganan_pengaduan")}>
                            <option disabled selected>Pilih salah satu ...</option>
                            <option value="1">Tidak Ada</option>
                            <option value="2">Ada tapi Tidak Berfungsi</option>
                            <option value="3">Berfungsi Kurang Maksimal</option>
                            <option value="4">Dikelola dengan Baik</option>
                        </select>
                    </div>
                    <div className="col-md-12 mb-4">
                        <label>Saran</label>
                        <textarea type="text" {...register("saran_saran")} rows={10} className='form-control'></textarea>
                    </div>
                    <div className="col-md-12">
                        <button type='submit' className='btn btn-success'>Kirim Survey Kepuasan Masyarakat</button>
                    </div>
                </div>
            </form>
        </div>
    )
};